import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Container, FlexContainer } from '../styles/StyledComponents';

const HeaderContainer = styled.header`
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1rem 0;
`;

const Logo = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: var(--primary-color);
  font-family: var(--font-family);

  span {
    color: var(--secondary-color);
  }
`;

interface NavProps {
  isOpen?: boolean;
}

const Nav = styled.nav<NavProps>`
  ul {
    display: flex;
    list-style: none;

    @media (max-width: 768px) {
      flex-direction: ${props => props.isOpen ? 'column' : 'row'};
      display: ${props => props.isOpen ? 'flex' : 'none'};
      position: absolute;
      top: 60px;
      left: 0;
      right: 0;
      background-color: white;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      z-index: 10;
      padding: 1rem 0;
    }

    li {
      margin-left: 2rem;

      @media (max-width: 768px) {
        margin: 0.5rem 0;
        text-align: center;
      }

      a {
        color: var(--text-color);
        font-weight: bold;
        transition: color 0.3s ease;
        font-family: var(--font-family);

        &:hover {
          color: var(--primary-color);
        }
      }
    }
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--primary-color);

  @media (max-width: 768px) {
    display: block;
  }
`;

const ParentLink = styled(Link)`
  font-size: 0.9rem;
  color: #666;
  position: absolute;
  top: 10px;
  right: 20px;
  transition: color 0.3s ease;
  font-family: var(--font-family);

  &:hover {
    color: var(--primary-color);
  }
`;

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <HeaderContainer>
      <ParentLink to="/parent">Parents</ParentLink>
      <Container>
        <FlexContainer justify="space-between" align="center">
          <Logo>
            <Link to="/">
              Kid<span>Games</span>
            </Link>
          </Logo>
          <MobileMenuButton onClick={toggleMenu}>
            {isMenuOpen ? '✕' : '☰'}
          </MobileMenuButton>
          <Nav isOpen={isMenuOpen}>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/games/number-quest">Number Quest</Link>
              </li>
              <li>
                <Link to="/games/pattern-puzzle">Pattern Puzzle</Link>
              </li>
              <li>
                <Link to="/games/sentence-scramble">Sentence Scramble</Link>
              </li>
              <li>
                <Link to="/games/phonics-factory">Phonics Factory</Link>
              </li>
            </ul>
          </Nav>
        </FlexContainer>
      </Container>
    </HeaderContainer>
  );
};

export default Header;
